import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { Datepicker, InputDataForForm, Organization, Res } from 'src/app/models';
import { ApiOrganizationsService, DatetimeService, LanguageService, NotificationService } from 'src/app/services';

@Component({
  selector: 'app-organization-create',
  templateUrl: './organization-create.component.html',
  styleUrls: ['./organization-create.component.css']
})
export class OrganizationCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  formData: Organization;
  formValid: boolean = false;
  langValid: boolean = false;
  inputDataForForm: InputDataForForm;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private router: Router,
    private datetimeService: DatetimeService,
    private notification: NotificationService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   * @param value any
   */
   setData(value: any): void {

    console.log("VALUE VALID: ", value);
    

    this.formData  = value.form
    this.formValid = value.valid
    this.langValid = value.langValid
  }


  /**
   * 
   */
  onCreate(): void {

    if(this.formData.vat_payer.date != null){

      this.formData.vat_payer.date = this.datetimeService.convertDateForDB(<Datepicker>this.formData.vat_payer.date)
    }

    console.log('form: ', this.formData);

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrganizations.create(this.formData).subscribe((response: Res) => { console.log('[RESPONSE] create organization: ', response);
          
        if(response != null){
        
          this.inputDataForForm = { action: 'create' }
          this.router.navigate(['organizations']);
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
      error => { 
        this.progressRef.complete();
      })
    );
  }

}
